// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-field-editor-container {
  width: 100%;
}

.tree-editor-legend {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tree-editor-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-height: 60px;
}

.field-node-wrapper {
  display: flex;
  flex-direction: column;
}

.field-node-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 6px;
  background: #FAFAFA;
  border: 1px solid #F0F0F0;
  transition: background 0.15s, border-color 0.15s;
  flex-wrap: nowrap;
  min-height: 38px;
}

.field-node-row:hover {
  background: #F0F7FF;
  border-color: #91CAFF;
}

.field-node-expand-btn {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 28px;
}

.field-node-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
  flex-shrink: 0;
  height: 28px;
}

.field-node-children {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
  border-left: 2px solid #E6F4FF;
  margin-left: 12px;
  padding-left: 8px;
}

.array-values-inline {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
  row-gap: 4px;
}

.array-value-item {
  display: flex;
  align-items: center;
  gap: 2px;
}

.field-node-type-hint {
  font-size: 12px;
  color: #8C8C8C;
  font-style: italic;
  flex: 1;
}

.field-depth-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 10px;
  box-shadow: 0 0 0 2px rgba(255,255,255,0.8), 0 0 0 3px currentColor;
}

.field-type-select .ant-select-selector {
  border-radius: 12px !important;
  font-size: 12px !important;
  padding: 0 8px !important;
}

.field-type-select.type-string .ant-select-selector {
  background: #F5F5F5 !important;
  border-color: #D9D9D9 !important;
}

.field-type-select.type-string .ant-select-selection-item {
  color: #595959 !important;
  font-weight: 500 !important;
}

.field-type-select.type-string:hover .ant-select-selector {
  border-color: #BFBFBF !important;
  background: #EBEBEB !important;
}

.field-type-select.type-array .ant-select-selector {
  background: #FFF7E6 !important;
  border-color: #FFD591 !important;
}

.field-type-select.type-array .ant-select-selection-item {
  color: #FA8C16 !important;
  font-weight: 500 !important;
}

.field-type-select.type-array:hover .ant-select-selector {
  border-color: #FFA940 !important;
  background: #FFF1CC !important;
}

.field-type-select.type-object .ant-select-selector {
  background: #F0F7FF !important;
  border-color: #91CAFF !important;
}

.field-type-select.type-object .ant-select-selection-item {
  color: #1677FF !important;
  font-weight: 500 !important;
}

.field-type-select.type-object:hover .ant-select-selector {
  border-color: #4096FF !important;
  background: #E6F4FF !important;
}

.field-type-select.ant-select-focused .ant-select-selector {
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1) !important;
}

.field-type-select-popup .ant-select-item {
  border-radius: 6px;
  font-size: 12px;
}

.field-type-select-popup .ant-select-item-option-selected {
  background: #E6F4FF !important;
  color: #1677FF !important;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/TreeFieldEditor/TreeFieldEditor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gDAAgD;EAChD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,OAAO;EACP,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".tree-field-editor-container {\n  width: 100%;\n}\n\n.tree-editor-legend {\n  margin-bottom: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tree-editor-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-height: 60px;\n}\n\n.field-node-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.field-node-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 5px 8px;\n  border-radius: 6px;\n  background: #FAFAFA;\n  border: 1px solid #F0F0F0;\n  transition: background 0.15s, border-color 0.15s;\n  flex-wrap: nowrap;\n  min-height: 38px;\n}\n\n.field-node-row:hover {\n  background: #F0F7FF;\n  border-color: #91CAFF;\n}\n\n.field-node-expand-btn {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  height: 28px;\n}\n\n.field-node-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: auto;\n  flex-shrink: 0;\n  height: 28px;\n}\n\n.field-node-children {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 2px;\n  border-left: 2px solid #E6F4FF;\n  margin-left: 12px;\n  padding-left: 8px;\n}\n\n.array-values-inline {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  flex: 1;\n  min-width: 0;\n  row-gap: 4px;\n}\n\n.array-value-item {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.field-node-type-hint {\n  font-size: 12px;\n  color: #8C8C8C;\n  font-style: italic;\n  flex: 1;\n}\n\n.field-depth-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 10px;\n  box-shadow: 0 0 0 2px rgba(255,255,255,0.8), 0 0 0 3px currentColor;\n}\n\n.field-type-select .ant-select-selector {\n  border-radius: 12px !important;\n  font-size: 12px !important;\n  padding: 0 8px !important;\n}\n\n.field-type-select.type-string .ant-select-selector {\n  background: #F5F5F5 !important;\n  border-color: #D9D9D9 !important;\n}\n\n.field-type-select.type-string .ant-select-selection-item {\n  color: #595959 !important;\n  font-weight: 500 !important;\n}\n\n.field-type-select.type-string:hover .ant-select-selector {\n  border-color: #BFBFBF !important;\n  background: #EBEBEB !important;\n}\n\n.field-type-select.type-array .ant-select-selector {\n  background: #FFF7E6 !important;\n  border-color: #FFD591 !important;\n}\n\n.field-type-select.type-array .ant-select-selection-item {\n  color: #FA8C16 !important;\n  font-weight: 500 !important;\n}\n\n.field-type-select.type-array:hover .ant-select-selector {\n  border-color: #FFA940 !important;\n  background: #FFF1CC !important;\n}\n\n.field-type-select.type-object .ant-select-selector {\n  background: #F0F7FF !important;\n  border-color: #91CAFF !important;\n}\n\n.field-type-select.type-object .ant-select-selection-item {\n  color: #1677FF !important;\n  font-weight: 500 !important;\n}\n\n.field-type-select.type-object:hover .ant-select-selector {\n  border-color: #4096FF !important;\n  background: #E6F4FF !important;\n}\n\n.field-type-select.ant-select-focused .ant-select-selector {\n  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1) !important;\n}\n\n.field-type-select-popup .ant-select-item {\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.field-type-select-popup .ant-select-item-option-selected {\n  background: #E6F4FF !important;\n  color: #1677FF !important;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
